var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEthereumIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_850_13290)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_850_13290",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 26
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 0H0V26H26V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_850_13290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.998 2.11377L12.8474 2.60994V17.0074L12.9937 17.1537L19.6767 13.2028L12.998 2.11377Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9979 2.11377L6.31372 13.2028L12.9979 17.1537V2.11377Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9991 18.4169L12.9167 18.5177V23.6462L12.9991 23.8867L19.6854 14.4692L12.9991 18.4169Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9979 23.8868V18.417L6.31372 14.4683L12.9979 23.8868Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0022 17.1561L19.6853 13.2051L13.0022 10.1675V17.1561Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.31372 13.2051L12.9979 17.1561V10.1675L6.31372 13.2051Z",
    fill: "#393939"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_850_13290"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereumIcon);
export default __webpack_public_path__ + "static/media/Ethereum-icon.8faca6a1f00a520f82d4b904387754c3.svg";
export { ForwardRef as ReactComponent };